var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCuttingEdgeProtectionH5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 80,
    viewBox: "0 0 160 80",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_437_3335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H160V80H0V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4001 52.7996C68.4001 44.4049 75.2054 37.5996 83.6001 37.5996C91.9949 37.5996 98.8001 44.4049 98.8001 52.7996V55.5996H68.4001V52.7996Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4001 52.7996C72.4001 46.614 77.4146 41.5996 83.6001 41.5996C89.7857 41.5996 94.8001 46.614 94.8001 52.7996V55.5996H72.4001V52.7996Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.2 55.5996H108V76.3996C108 78.1669 106.567 79.5996 104.8 79.5996H103.2V55.5996Z",
    stroke: "black",
    strokeWidth: 1.33333,
    strokeDasharray: "2.56 2.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.6 56C135.6 27.2812 112.319 4 83.6 4C61.5108 4 42.6385 17.7731 35.1024 37.2",
    stroke: "black",
    strokeWidth: 1.33333,
    strokeDasharray: "2.56 2.56"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.1998,
    cy: 37.2008,
    r: 2.4,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 58.7996C60 57.0323 61.4327 55.5996 63.2 55.5996H64.8V79.5996H60V58.7996Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.7999,
    y: 55.5996,
    width: 38.4,
    height: 24,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.5999,
    cy: 66.3996,
    r: 2.13333,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5996 69.1992V73.9992",
    stroke: "black",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 66.8,
    r: 12.8,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 137.6,
    cy: 66.8,
    r: 12.8,
    fill: "#304FF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.343 59.5996V73.9996",
    stroke: "white",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.428 59.5996V73.9996",
    stroke: "white",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.343 66.7995H138.943C140.221 66.7995 141.257 65.7633 141.257 64.4852C141.257 63.207 140.221 62.1709 138.943 62.1709H135.343V66.7995Z",
    fill: "#304FF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.029 62.1709H135.343M135.343 62.1709H138.943C140.221 62.1709 141.257 63.207 141.257 64.4852V64.4852C141.257 65.7633 140.221 66.7995 138.943 66.7995H135.343V62.1709Z",
    stroke: "white",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.343 66.8001H139.457C140.735 66.8001 141.771 67.8363 141.771 69.1144C141.771 70.3926 140.735 71.4287 139.457 71.4287H135.343V66.8001Z",
    fill: "#304FF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.029 71.4287H135.343M135.343 71.4287H139.457C140.735 71.4287 141.771 70.3926 141.771 69.1144V69.1144C141.771 67.8363 140.735 66.8001 139.457 66.8001H135.343V71.4287Z",
    stroke: "white",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 56.0004C46 35.2345 62.8341 18.4004 83.6 18.4004C104.366 18.4004 121.2 35.2345 121.2 56.0004H111.6C111.6 48.2178 108.424 41.1768 103.298 36.1022L105.561 33.8394C99.9233 28.2519 92.1645 24.8008 83.5997 24.8008C74.9629 24.8008 67.1458 28.3101 61.4965 33.9806L63.7592 36.2433C58.7166 41.3069 55.5997 48.2897 55.5996 56.0004H46Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 56.0004H45.3333V56.6671H46V56.0004ZM121.2 56.0004V56.6671H121.867V56.0004H121.2ZM111.6 56.0004L110.933 56.0004L110.933 56.6671H111.6V56.0004ZM103.298 36.1022L102.827 35.6308L102.353 36.1046L102.829 36.576L103.298 36.1022ZM105.561 33.8394L106.033 34.3108L106.506 33.8373L106.031 33.3659L105.561 33.8394ZM61.4965 33.9806L61.0242 33.5101L60.5546 33.9815L61.0251 34.452L61.4965 33.9806ZM63.7592 36.2433L64.2316 36.7137L64.701 36.2423L64.2306 35.7719L63.7592 36.2433ZM55.5996 56.0004V56.6671H56.2663L56.2663 56.0004L55.5996 56.0004ZM83.6 17.7337C62.4659 17.7337 45.3333 34.8663 45.3333 56.0004H46.6667C46.6667 35.6027 63.2023 19.0671 83.6 19.0671V17.7337ZM121.867 56.0004C121.867 34.8663 104.734 17.7337 83.6 17.7337V19.0671C103.998 19.0671 120.533 35.6027 120.533 56.0004H121.867ZM111.6 56.6671H121.2V55.3337H111.6V56.6671ZM112.266 56.0004C112.266 48.0326 109.015 40.8231 103.768 35.6284L102.829 36.576C107.834 41.5305 110.933 48.4029 110.933 56.0004L112.266 56.0004ZM103.77 36.5736L106.033 34.3108L105.09 33.368L102.827 35.6308L103.77 36.5736ZM106.031 33.3659C100.273 27.6597 92.3473 24.1341 83.5997 24.1341V25.4674C91.9817 25.4674 99.5738 28.8441 105.092 34.3129L106.031 33.3659ZM83.5997 24.1341C74.7786 24.1341 66.7935 27.7192 61.0242 33.5101L61.9688 34.4511C67.4981 28.9011 75.1473 25.4674 83.5997 25.4674V24.1341ZM61.0251 34.452L63.2878 36.7147L64.2306 35.7719L61.9679 33.5092L61.0251 34.452ZM63.2868 35.7729C58.1249 40.9563 54.9331 48.1062 54.9329 56.0004L56.2663 56.0004C56.2664 48.4731 59.3084 41.6575 64.2316 36.7137L63.2868 35.7729ZM46 56.6671H55.5996V55.3337H46V56.6671Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.2002,
    y: 73.1992,
    width: 9.6,
    height: 6.4,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.4001,
    y: 75.5996,
    width: 9.6,
    height: 4,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7999 70H27.1999C28.9672 70 30.3999 71.4327 30.3999 73.2V79.6H12.7999V70Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4001 69.5996L18.4001 39.5996",
    stroke: "black",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4001 43.5996H26.4001C27.2838 43.5996 28.0001 44.316 28.0001 45.1996V53.9996H18.4001V43.5996Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 45.5996H37.6L37.3693 46.2495C36.3243 49.1929 36.3243 52.4063 37.3693 55.3498L37.6 55.9996H29.6C28.7163 55.9996 28 55.2833 28 54.3996V45.5996Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.33333
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_437_3335"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCuttingEdgeProtectionH5);
export default __webpack_public_path__ + "static/media/cutting_edge_protection_h5.53c1e67de01574dfaea748415fe41405.svg";
export { ForwardRef as ReactComponent };